// @ts-nocheck
/**
 * One-step onboarding for Admin+ Calendar when opened with ?tour=true.
 * @param {object} vm - Vue component instance with $t
 */
export function buildCalendarAdminPlusTourSteps(vm) {
  const t = (key) => vm.$t(key);
  return [
    {
      target: '[data-v-step="3"]',
      icon: require("@/assets/icons/admin+/academy_calendar.svg"),
      label: t("message.onboarding_calendar_label"),
      title: t("message.onboarding_calendar_title"),
      autoClick: true,
      description: t("message.onboarding_calendar_description"),
      before() {
        const element = document.querySelector('[data-v-step="3"]');
        if (element) {
          element.click();
        }
      },
      params: {
        placement: "left",
        highlight: true,
      },
    },
  ];
}
